/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Meta_DescriptionInputs */

const ja_work_meta_description = /** @type {(inputs: Work_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイブレーン(PLAYBRAIN)の制作実績について紹介します。マーケティング、eスポーツイベントの制作と運営、プロダクト開発の分野で多数の実績があります。`)
};

const en_work_meta_description = /** @type {(inputs: Work_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let me introduce PLAYBRAIN's portfolio. We have numerous achievements in marketing, esports event production and management, and product development.`)
};

/**
* | output |
* | --- |
* | "Let me introduce PLAYBRAIN's portfolio. We have numerous achievements in marketing, esports event production and management, and product development." |
*
* @param {Work_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const work_meta_description = /** @type {((inputs?: Work_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_meta_description(inputs)
	return en_work_meta_description(inputs)
});